export type FounderToggleProps = {
  founder: boolean;
  onChange: (founder: boolean) => void | Promise<void>;
};

/** Platform-admin founder flag. Dumb view: state via props. */
export function FounderToggle({ founder, onChange }: FounderToggleProps) {
  return (
    <label className="platform-founder-toggle" data-platform-founder-toggle>
      <input type="checkbox" checked={founder} onChange={(e) => void onChange(e.target.checked)} />
      Founder (never billed, full Pro)
    </label>
  );
}
